export default __webpack_public_path__ + "static/media/high-score.47ca529f.png";